import { useEffect, useState } from "react";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import sparkles from '../../../../../shared/assets/images/Sparkles.svg'
import like from '../../../../../shared/assets/images/like.svg'
import dislike from '../../../../../shared/assets/images/dislike.svg'
import blueLike from '../../../../../shared/assets/images/blueLike.svg'
import blueDislike from '../../../../../shared/assets/images/blueDislike.svg'
import clipboardList from '../../../../../shared/assets/images/ClipboardList.svg'
import grayPlay from '../../../../../shared/assets/images/grayPlay.svg'
import { IGetFeedback, ReactionTypeId } from "../../../../../shared/utils/interfaces/commentsFaces";
import { useReactToEvaluationMutation } from "../../../../interview/slice/interviewApiSlice";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { setAiEvaluationId, setIsRecordedInterviewModalOpen, setIsViewEvaluationModalOpen, setRecordedVideoUrl } from "../../../../interview/slice/interviewSlice";

export default function AiEvaluationSummary({feedback, text} : {feedback : IGetFeedback; text : string | React.ReactNode;}) {
    const dispatch = useDispatch();
    const [postedSince, setPostedSince] = useState<string>();
    const [updatedSince, setUpdatedSince] = useState<string>();
    const [duration, setDuration] = useState<string>()
    const [reactToEvaluation] = useReactToEvaluationMutation();
    const [localReaction, setLocalReaction] = useState<number | null>(feedback?.data?.reaction?.id ?? null);

    useEffect(() => {
        if(!duration) {
            const parts = feedback?.data?.duration?.split(":");
            const displayTime = parts?.length === 3 ? `${parts[1]}:${parts[2]}` : feedback?.data?.duration;
            setDuration(displayTime)
        }
    }, [feedback?.data?.duration, duration])

    useEffect(() => {
        dayjs.extend(relativeTime)
        setPostedSince(dayjs().to(dayjs(feedback?.createdAt)))
        setUpdatedSince(dayjs().to(dayjs(feedback?.updatedAt)))
    }, [feedback?.createdAt, feedback?.updatedAt])

    const handleReactToEvaluation = async (react: ReactionTypeId) => {
        const newReaction = localReaction === react ? ReactionTypeId.unReact : react;
        setLocalReaction(newReaction === ReactionTypeId.unReact ? null : newReaction);

        const reactionData = {"reactionTypeId": newReaction, "applicationEvaluationId": feedback?.data?.applicationEvaluationId}
        try {
            const response = await reactToEvaluation(reactionData);
            const { isSuccess, isError, error } = response;
            if (isSuccess) {
                return
            } else if (isError) {
                message.error(error?.data?.message)
                setLocalReaction(feedback?.data?.reaction?.id ?? null);   
            }
        } catch (error) {
            console.error(error);
            setLocalReaction(feedback?.data?.reaction?.id ?? null);
        }
    }

    const displayRecorededInterviewModal = () =>{
        dispatch(setRecordedVideoUrl(feedback?.data?.videoUrl))
        dispatch(setIsRecordedInterviewModalOpen(true));
    }
    
    const displayEvaluationModal = () =>{
        dispatch(setAiEvaluationId(feedback?.data?.applicationEvaluationId))
        dispatch(setIsViewEvaluationModalOpen(true));
    }

    return (
        <div
            className='flex items-start gap-[0.875rem] mt-4 mb-5 flex-nowrap pe-2 transition-all duration-300 ease-in-out'
        >
            <span className='flex justify-center items-center min-w-[2rem] w-8 h-8 bg-indigo-600 rounded-full font-normal'>
                <img src={sparkles} alt="*" className="w-[1.125rem] h-[1.125rem]"/>
            </span>
            <div className="w-full">
                <div className='flex items-center flex-nowrap gap-2 mb-1.5'>
                    <span className='text-sm font-semibold text-gray-600'>{feedback?.name}</span>
                    <span className='text-xs font-normal text-gray-400 whitespace-nowrap'><span>{feedback?.updatedAt ? 'Edited' : ''}</span> {feedback?.updatedAt ? updatedSince : postedSince}
                    </span>
                    <span className='text-xs font-normal text-gray-400 whitespace-nowrap'>|</span>
                    <div className="flex gap-2 w-10 h-4">
                        <img
                            src={localReaction === ReactionTypeId.like ? blueLike : like}
                            alt="like"
                            className="w-4 h-4 hover:cursor-pointer"
                            onClick={() => handleReactToEvaluation(ReactionTypeId.like)}
                        />
                        <img
                            src={localReaction === ReactionTypeId.dislike ? blueDislike : dislike}
                            alt="dislike"
                            className="w-4 h-4 hover:cursor-pointer"
                            onClick={() => handleReactToEvaluation(ReactionTypeId.dislike)}
                        />
                    </div>
                </div>
                <div className='text-sm text-gray-600 break-words min-w-fit mb-[0.625rem]'>{text}</div>
                <div className="flex flex-col md:flex-row gap-4 w-full md:h-16">
                    <div className="flex items-center gap-[0.625rem] w-[11.75rem] md:w-fit rounded-md p-3 pr-4 bg-gray-200 cursor-pointer" onClick={displayEvaluationModal}>
                        <img src={clipboardList} alt="summary" className="w-6 h-6"/>
                        <div className="text-sm text-gray-600">
                            <p className="md:max-w-60 max-w-32 truncate">{feedback?.data?.job?.title}</p>
                            <p>score <span className="font-bold">{feedback?.data?.score}/10</span></p>
                        </div>
                    </div>
                    <div className="flex items-center gap-[0.625rem] w-[11.75rem] md:w-fit rounded-md p-3 pr-4 bg-gray-200 cursor-pointer" onClick={displayRecorededInterviewModal}>
                        <img src={grayPlay} alt="watch" className="w-6 h-6"/>
                        <div className="text-sm text-gray-600">
                            <p>
                                Watch Interview
                            </p>
                            <p className="text-xs leading-5">
                                {duration}
                                {duration && duration?.split(":")?.length === 2 ? ' min' : duration && duration?.split(":")?.length === 3 ? ' hr' : ''}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}